import React, { useState, useEffect } from 'react';

import client from 'utils/client';

import { Loader } from '../../reusable-components/misc';
import DetailComponent from '../components/DetailComponent';
import VerticalHorizontalSlider from '../components/VerticalHorizontalSlicer';

function DisplayBox(props) {
  const [selected, setSelected] = useState({});
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelFetch = false;
    if (!cancelFetch) {
      setLoading(true);
      const fetchCollections = () => {
        client
          .get(
            `/teamsport/brands_collections/?teamsport_brand_id=${props.brand.id}`
          )
          .then(res => {
            if (!cancelFetch) {
              setCollections(res.data.collections);
              setSelected(res.data.collections[0]);
              setLoading(false);
            }
          })
          .catch(() => {
            setError(true);
            setLoading(false);
          });
      };
      fetchCollections();
    }
    return () => {
      cancelFetch = true;
    };
  }, []);

  const totalSliderLength = collections && collections.length;

  const handleClick = (e, shirt) => {
    setSelected(shirt);
  };

  return (
    <div
      className={`section ${props.sectionClass}`}
      id={props.brand.id}
      key={`key-${props.brand.id}`}
    >
      {/* <div className="absolute-flex"> */}
      <div className="mainWidth">
        {loading && <Loader />}
        {error && <p>problem on data</p>}
        {collections && (
          <VerticalHorizontalSlider
            totalSlides={totalSliderLength}
            handleClick={handleClick}
            slidesToShowDesktop={3}
            slidesToShowMobile={3}
            slidesToScrollDesktop={1}
            slidesToScrollMobile={1}
            autoplay={false}
            infinite={false}
            focusOnSelect={false}
            touchThreshold={15}
            speed={300}
            data={collections}
            translations={props.translations}
            brand={props.brand.name}
          />
        )}
        {collections &&
          collections.map(shirt => {
            return (
              <DetailComponent
                key={shirt.id}
                shirt={shirt}
                brand={props.brand.name}
                style={{ display: selected.id === shirt.id ? 'flex' : 'none' }}
              />
            );
          })}
      </div>
      {/* </div> */}
    </div>
  );
}

export default DisplayBox;
